import gql from 'graphql-tag';

export const CHECK_SERVICEABILITY = gql`
  query CheckServiceability($options: SolarServiceabilityOptions!) {
    checkServiceability(options: $options) {
      serviceable
    }
  }
`;

export const CHECK_REPAIR_SERVICEABILITY = gql`
  query CheckRepairServiceability($options: RepairServiceabilityOptions!) {
    checkRepairServiceability(options: $options) {
      serviceable
    }
  }
`;

export const CALCULATE_SOLAR_SAVINGS = gql`
  query CalculateSolarSaving($options: SolarRecommendationOptions!) {
    calculateSolarRecommendations(options: $options) {
      primaryRecommendationId
      estimatedSystemSizeWatts
      recommendations {
        id
        solarSystem {
          id
          name
          description
          size
          inverter {
            watts
          }
          solarPanels {
            panelCount
          }
          totalCost
        }
        solarSaving {
          billCostForPeriod
          billPeriod
          billSavingsForPeriod
          payoffTimeYears
          usagePercentDuringDay
          solarEnergyConsumedKwh
          solarEnergyConsumptionRateCents
          solarEnergyConsumedDollars
          solarEnergySoldKwh
          solarEnergySoldDollars
          solarEnergySoldRateCents
        }
      }
    }
  }
`;
